import PieChartEng from "../components/pie-chart_Eng.js";

const Ortaklik = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Partnership Structure</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-12 mt-4">
          <PieChartEng />
        </div>
      </div>
    </>
  );
};

export default Ortaklik;
